export default __webpack_public_path__ + "static/media/logo-syndic-one-colored.2624a148.svg";